import { ASPECT_RATIO_THRESHOLDS } from './aspect-ratio-constants';
import { getPhotoAspectRatio } from './preview-image';

import type { ExperiencePhoto } from '../types/experience';

/**
 * Определяет CSS класс для мобильного фото
 * Возвращает 'vertical' или 'horizontal' на основе aspect ratio
 */
export function getMobilePhotoClass(photo: ExperiencePhoto): string {
  const aspectRatio = getPhotoAspectRatio(photo);
  if (aspectRatio === null) {
    return 'horizontal';
  }

  if (aspectRatio >= ASPECT_RATIO_THRESHOLDS.SQUARE_MIN && aspectRatio <= ASPECT_RATIO_THRESHOLDS.SQUARE_MAX) {
    return 'horizontal';
  }

  if (aspectRatio < ASPECT_RATIO_THRESHOLDS.SQUARE_MIN) {
    return 'vertical';
  }

  return 'horizontal';
}
